import React from "react";
import { DataTieringVisualisation, DataTieringConfiguration } from "components/indices/data-tiering";
const IndexSetRotationRetentionDataTieringConfiguration = ({
  values,
  hiddenFields = [],
  immutableFields = [],
  ignoreFieldRestrictions
}) => {
  var _a, _b, _c, _d, _e;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    DataTieringVisualisation,
    {
      minDays: (_a = values.data_tiering) == null ? void 0 : _a.index_lifetime_min,
      maxDays: (_b = values.data_tiering) == null ? void 0 : _b.index_lifetime_max,
      minDaysInHot: (_c = values.data_tiering) == null ? void 0 : _c.index_hot_lifetime_min,
      warmTierEnabled: (_d = values.data_tiering) == null ? void 0 : _d.warm_tier_enabled,
      archiveData: (_e = values.data_tiering) == null ? void 0 : _e.archive_before_deletion
    }
  ), (!hiddenFields.includes("data_tiering") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    DataTieringConfiguration,
    {
      hiddenFields,
      immutableFields,
      ignoreFieldRestrictions
    }
  ));
};
export default IndexSetRotationRetentionDataTieringConfiguration;
